import { breakpoints, resets } from '@ui/css';
import { Row, SortableColumnHeading, ColumnHeading } from '@ui/kit';
import { HideFor, ShowFor } from '@utils/react';
import { rowSizingCls } from './table.item.style.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function THead(props) {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(HideFor, {
      breakpoint: breakpoints.mobile,
      children: /*#__PURE__*/jsxs(Row, {
        as: "header",
        sizingCls: rowSizingCls,
        children: [/*#__PURE__*/jsx(SortableColumnHeading, {
          active: props.options.sortBy === "componentTitle",
          direction: props.options.direction,
          onSort: () => props.onSort("componentTitle"),
          children: "Titel"
        }), /*#__PURE__*/jsx(SortableColumnHeading, {
          active: props.options.sortBy === "productTitle",
          direction: props.options.direction,
          onSort: () => props.onSort("productTitle"),
          children: "L\xE6remiddel"
        }), /*#__PURE__*/jsx(SortableColumnHeading, {
          active: props.options.sortBy === "date",
          direction: props.options.direction,
          onSort: () => props.onSort("date"),
          children: "Dato"
        }), /*#__PURE__*/jsx(ColumnHeading, {
          children: "Antal svar"
        }), /*#__PURE__*/jsx(ColumnHeading, {
          label: "Dialog"
        })]
      })
    }), /*#__PURE__*/jsx(ShowFor, {
      breakpoint: breakpoints.mobile,
      children: /*#__PURE__*/jsxs(Row, {
        as: "header",
        sizingCls: rowSizingCls,
        className: resets.screenReaderOnlyCls,
        children: [/*#__PURE__*/jsx(ColumnHeading, {
          label: "Titel"
        }), /*#__PURE__*/jsx(ColumnHeading, {
          label: "L\xE6remiddel"
        }), /*#__PURE__*/jsx(ColumnHeading, {
          label: "Status"
        }), /*#__PURE__*/jsx(ColumnHeading, {
          label: "Dialog"
        }), /*#__PURE__*/jsx(ColumnHeading, {
          label: "Antal svar"
        })]
      })
    })]
  });
}

export { THead };
//# sourceMappingURL=table.thead.js.map
